const CalendarMessages = ({ activeMessages }) => {
	if (!activeMessages || !activeMessages.length) return null;

	return (
		<ul className="message-list">
			{activeMessages.map(({ message }, index) => {
				return (
					<li className="message-list__item" key={`${index}-${message}`}>
						{message}
					</li>
				);
			})}
		</ul>
	);
};

export default CalendarMessages;
